var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDateTime01 = function SvgIconDateTime01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_date_time-01_svg2__a",
    x1: -17.75,
    x2: 100.25,
    y1: 26.9,
    y2: 98.95,
    gradientTransform: "matrix(1 0 0 -1 0 102)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_date_time-01_svg2__a",
    id: "icon_date_time-01_svg2__b",
    x1: -21.37,
    x2: 96.58,
    y1: 32.88,
    y2: 104.88
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_date_time-01_svg2__a",
    id: "icon_date_time-01_svg2__c",
    x1: -15.21,
    x2: 102.79,
    y1: 22.76,
    y2: 94.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_date_time-01_svg2__a",
    id: "icon_date_time-01_svg2__d",
    x1: -10.26,
    x2: 107.74,
    y1: 14.67,
    y2: 86.67
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_date_time-01_svg2__a",
    id: "icon_date_time-01_svg2__e",
    x1: -11.24,
    x2: 106.71,
    y1: 16.28,
    y2: 88.28
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_date_time-01_svg2__a",
    id: "icon_date_time-01_svg2__f",
    x1: -5.44,
    x2: 112.51,
    y1: 6.79,
    y2: 78.84
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_date_time-01_svg2__a",
    id: "icon_date_time-01_svg2__g",
    x1: 7.4,
    x2: 125.4,
    y1: -14.25,
    y2: 57.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_date_time-01_svg2__a",
    id: "icon_date_time-01_svg2__h",
    x1: 6.51,
    x2: 124.46,
    y1: -12.82,
    y2: 59.23
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M45.3 84.1H11.35c-3.75 0-6.8-3.05-6.8-6.8V29.55h75V43.9c0 1.25 1 2.25 2.25 2.25s2.25-1 2.25-2.25V18.15c0-6.25-5.1-11.35-11.35-11.35h-4.55c0-3.75-3.05-6.8-6.8-6.8s-6.8 3.05-6.8 6.8h-25c0-3.75-3.05-6.8-6.8-6.8s-6.8 3.05-6.8 6.8H11.4C5.1 6.85 0 11.9 0 18.2v59.1c0 6.25 5.1 11.35 11.35 11.35H45.3c1.25 0 2.25-1 2.25-2.25s-1-2.25-2.25-2.25zM59.1 6.8c0-1.25 1-2.25 2.25-2.25s2.25 1 2.25 2.25v4.55c0 1.25-1 2.25-2.25 2.25s-2.25-1-2.25-2.25zm-38.65 0c0-1.25 1-2.25 2.25-2.25s2.25 1 2.25 2.25v4.55c0 1.25-1 2.25-2.25 2.25s-2.25-1-2.25-2.25zM4.55 18.2c0-3.75 3.05-6.8 6.8-6.8h4.55c0 3.75 3.05 6.8 6.8 6.8s6.8-3.05 6.8-6.8h25c0 3.75 3.05 6.8 6.8 6.8s6.8-3.05 6.8-6.8h4.55c3.75 0 6.8 3.05 6.8 6.8V25H4.55z",
    style: {
      fill: "url(#icon_date_time-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.25 40.9c0-2.5-2.05-4.55-4.55-4.55h-6.8c-2.5 0-4.55 2.05-4.55 4.55v6.8c0 2.5 2.05 4.55 4.55 4.55h6.8c2.5 0 4.55-2.05 4.55-4.55zM15.9 47.75v-6.8h6.8v6.8z",
    style: {
      fill: "url(#icon_date_time-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 40.9c0-2.5-2.05-4.55-4.55-4.55h-6.8c-2.5 0-4.55 2.05-4.55 4.55v6.8c0 2.5 2.05 4.55 4.55 4.55h6.8c2.5 0 4.55-2.05 4.55-4.55zm-11.35 6.85v-6.8h6.8v6.8z",
    style: {
      fill: "url(#icon_date_time-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.45 45.75c1.25 0 2.25-1 2.25-2.25v-2.6c0-2.5-2.05-4.55-4.55-4.55h-6.8c-2.5 0-4.55 2.05-4.55 4.55v6.55c0 1.25 1 2.25 2.25 2.25s2.25-1 2.25-2.25V40.9h6.8v2.6c0 1.25 1 2.25 2.25 2.25z",
    style: {
      fill: "url(#icon_date_time-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 59.1h-6.8c-2.5 0-4.55 2.05-4.55 4.55v6.8c0 2.5 2.05 4.55 4.55 4.55h6.8c2.5 0 4.55-2.05 4.55-4.55v-6.8c0-2.5-2.05-4.55-4.55-4.55M15.9 70.45v-6.8h6.8v6.8z",
    style: {
      fill: "url(#icon_date_time-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 59.4c-.5-.2-1.05-.3-1.55-.3h-6.8c-2.5 0-4.55 2.05-4.55 4.55v6.8c0 2.5 2.05 4.55 4.55 4.55h4.65c1.25 0 2.25-1 2.25-2.25s-1-2.25-2.25-2.25h-4.65v-6.8h6.7c1.15.45 2.5-.15 2.95-1.3s-.1-2.45-1.25-2.95z",
    style: {
      fill: "url(#icon_date_time-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 50c-13.8 0-25 11.2-25 25s11.2 25 25 25 25-11.2 25-25-11.2-25-25-25m0 45.45c-11.3 0-20.45-9.15-20.45-20.45S63.7 54.55 75 54.55 95.45 63.7 95.45 75 86.3 95.45 75 95.45",
    style: {
      fill: "url(#icon_date_time-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.25 74.05v-10.4c0-1.25-1-2.25-2.25-2.25s-2.25 1-2.25 2.25V75c0 .6.25 1.2.65 1.6l4.55 4.55c.9.85 2.35.85 3.2-.05s.85-2.3 0-3.15z",
    style: {
      fill: "url(#icon_date_time-01_svg2__h)"
    }
  }));
};
export default SvgIconDateTime01;